import React, { useCallback } from 'react';

import { ModalWrapper } from '@/components/wrappers';

import CancelPlanTerminationModalForm from './PlanTerminationModalForms/CancelPlanTerminationModalForm';
import { useCancelPlanTerminationModalStore } from './store';

export const CancelPlanTerminationModal = () => {
  const handleChangeVisibility = useCancelPlanTerminationModalStore((state) => state.handleChangeVisibility);
  const modalVisible = useCancelPlanTerminationModalStore((state) => state.modalVisible);

  const handleSetVisible = useCallback(() => {
    handleChangeVisibility(false);
  }, [
    handleChangeVisibility,
  ]);

  return (
    <ModalWrapper
      testId="ModalWrapper"
      visible={modalVisible}
      onSetVisible={handleSetVisible}
    >
      <CancelPlanTerminationModalForm onCancel={handleSetVisible} />
    </ModalWrapper>
  );
};